// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__k2vTY","savePackageButton":"ClientWallet_savePackageButton__26eSA"};